import React from 'react';
// import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';

interface PaymentGracePeriodModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onDismiss: () => void;
    remainingDays: number;
}

const PaymentGracePeriodModal: React.FC<PaymentGracePeriodModalProps> = ({
    open,
    onOpenChange,
    onDismiss,
    remainingDays,
}) => {
    const { t } = useTranslation();

    const handleDismiss = () => {
        onDismiss();
        onOpenChange(false);
    };


    if (!open) {
        return null;
    }

    return (
        <>

            <div
                className="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-50"
                onClick={handleDismiss}
            />

            {/* Modal */}
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                <div className="relative bg-white rounded-xl shadow-xl max-w-md w-full p-4 sm:p-6 animate-in fade-in-0 zoom-in-95 duration-200">

                    {/* Icon and Title */}
                    <div className="flex items-start gap-4 mb-4">
                        {/* <div className="flex-shrink-0 mt-1">
                            <AlertCircle className="text-red-500" size={24} />
                        </div> */}
                        <div className="flex-1">
                            <h2 className="text-base sm:text-lg font-semibold mb-3">
                                {t('Payment_Issue_Detected')}
                            </h2>
                            <p className="text-xs text-medium-emphasis leading-relaxed">
                                {t('Your_payment_requires_attention_You_have')} <span className="font-bold">{remainingDays} {remainingDays === 1 ? 'day' : 'days'}</span> {t('Remaining_In_Your_Grace_Period_To_Do_So')}.
                            </p>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex justify-end gap-3 mt-6">
                        <Button
                            onClick={handleDismiss}
                            className="px-4 py-2 bg-primary text-gray-50 text-sm font-medium rounded-md hover:bg-gray-800 transition-colors"
                        >
                            Dismiss
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentGracePeriodModal;